import { Link } from 'react-router-dom';
import { FadeUp } from './Reveal';

export default function Footer() {
  return (
    <footer className="relative bg-ink-950 border-t border-white/10 mt-32" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-24 md:py-32">
        <FadeUp>
          <div className="max-w-5xl">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">— Let&apos;s talk in writing</p>
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-white font-light">
              An Italian lawyer <br />
              <em className="not-italic text-white/50">on your side in Italy.</em>
            </h2>
            <a
              href="#claim-form"
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 px-6 py-4 bg-white text-black text-[11px] font-mono uppercase tracking-[0.25em] hover:bg-oxblood hover:text-white transition-colors duration-300"
            >
              Submit Your Claim for Review
              <span aria-hidden>→</span>
            </a>
          </div>
        </FadeUp>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-4 gap-10 pt-10 border-t border-white/10">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">Studio</p>
            <p className="font-serif text-lg text-white leading-snug">
              Studio Legale Belliardo
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">Registered address</p>
            <p className="text-sm text-white/70 leading-relaxed">
              Salita Fontana del Ferro, 24 <br /> 37129 Verona · Italia
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">International practice</p>
            <a
              href="mailto:avvocati@studiobelliardo.it"
              className="text-sm text-white hover-underline"
              data-testid="footer-email"
            >
              avvocati@studiobelliardo.it
            </a>
            <span className="text-sm text-white/60 mt-1 block" data-testid="footer-phone">Tel. +39 045.8011276</span>
            <span className="text-sm text-white/60 mt-1 block" data-testid="footer-pec">PEC: avvchristianbelliardo@ordineavvocativrpec.it</span>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">Markets</p>
            <ul className="text-sm text-white/70 space-y-1">
              <li><Link to="/uae" className="hover-underline">United Arab Emirates</Link></li>
              <li><Link to="/usa" className="hover-underline">United States</Link></li>
              <li><Link to="/uk" className="hover-underline">United Kingdom</Link></li>
              <li><Link to="/germany" className="hover-underline">Germany</Link></li>
              <li><Link to="/france" className="hover-underline">France</Link></li>
              <li><Link to="/spain" className="hover-underline">Spain</Link></li>
              <li><Link to="/switzerland" className="hover-underline">Switzerland</Link></li>
              <li><Link to="/netherlands" className="hover-underline">Netherlands</Link></li>
              <li><Link to="/greece" className="hover-underline">Greece</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 grid grid-cols-1 md:grid-cols-2 gap-4 text-[11px] text-white/40 font-mono uppercase tracking-[0.2em]">
          <div>
            P.IVA 03995680232
          </div>
          <div className="md:text-right">
            Ordine Avvocati Verona N. 2726
          </div>
          <div className="md:col-span-2 text-white/40 mt-2">
            Professional Indemnity Insurance No. M11635296 · ITAS Mutua · renewed 30/01/2026
          </div>
          <div className="md:col-span-2 mt-4 flex gap-8 text-white/40">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-white transition-colors">Cookie Policy</Link>
            <Link to="/for-lawyers" data-testid="footer-counsel-link" className="hover:text-white transition-colors">For Counsel</Link>
          </div>
          <div className="md:col-span-2 text-white/30 mt-4 leading-relaxed normal-case tracking-normal font-sans">
            All content on this website is provided for informational purposes only and does not constitute legal
            advice or a solicitation. The information does not create an attorney–client relationship. Any reference
            to prior representations is illustrative and does not imply guarantee of outcome — as per Italian
            deontological rules (Codice Deontologico Forense, art. 35, 17 &amp; 12).
          </div>
        </div>
      </div>
    </footer>
  );
}
